import { API } from '@/utils/api'

const LOCALES_TTL = 2 * 60 * 1000 // 2 минуты

export default {
  loadTypes(context, force = false) {
    if (context.state.typesLoaded && !force) {
      return Promise.resolve(context.state.types)
    }

    return API.call('/cms/type/list.json', { perpage: 100 }).then(r => {
      const types = r.data.items || []
      context.commit('setTypes', types)
      return types
    })
  },
  loadLocales(context, force = false) {
    const fresh = context.state.localesLoadedAt > 0 &&
      (Date.now() - context.state.localesLoadedAt) < LOCALES_TTL
    if (fresh && !force) {
      return Promise.resolve(context.state.locales)
    }

    return API.call('/cms/locale/list.json', { is_active: true }).then(r => {
      const locales = (r.data && r.data.items) || []
      context.commit('setLocales', locales)
      return locales
    })
  },
}